import React, { useEffect, useState } from "react";
import { getAuthEvents } from "../lib/api";
import { History, CheckCircle2, ShieldAlert, AlertTriangle } from "lucide-react";

const OUTCOME = {
  ok: { icon: CheckCircle2, color: "text-[#22C55E]", label: "Accesso riuscito" },
  denied: { icon: ShieldAlert, color: "text-destructive", label: "Negato: email non autorizzata" },
  session_invalid: { icon: AlertTriangle, color: "text-[#EAB308]", label: "Sessione Google non valida" },
};

const fmt = (iso) => (iso || "").slice(0, 16).replace("T", " ");

export const AuthEventsCard = () => {
  const [items, setItems] = useState([]);
  useEffect(() => {
    getAuthEvents(30).then((d) => setItems(d.items || [])).catch((e) => console.warn("auth events load failed", e));
  }, []);

  return (
    <div className="rounded-xl border border-border bg-card p-6" data-testid="auth-events-card">
      <div className="mb-1 flex items-center gap-2">
        <History className="h-5 w-5 text-primary" strokeWidth={1.75} />
        <h3 className="font-heading text-lg font-semibold">Storico accessi</h3>
      </div>
      <p className="mb-4 text-sm text-muted-foreground">Ultimi tentativi di login con Google: chi, quando ed esito. Utile se qualcuno del team non riesce a entrare.</p>
      {items.length === 0 && <p className="text-xs text-muted-foreground" data-testid="auth-events-empty">Nessun tentativo registrato finora.</p>}
      <div className="space-y-1.5">
        {items.map((ev) => {
          const o = OUTCOME[ev.outcome] || OUTCOME.session_invalid;
          const Icon = o.icon;
          return (
            <div key={ev.id} className="flex items-center justify-between rounded-lg border border-border px-3 py-2 text-xs" data-testid={`auth-event-${ev.id}`}>
              <div className="flex items-center gap-2">
                <Icon className={`h-3.5 w-3.5 ${o.color}`} />
                <span className="font-medium">{ev.email || "—"}</span>
                <span className={o.color}>{o.label}</span>
              </div>
              <span className="text-muted-foreground tabular-nums">{fmt(ev.at)}</span>
            </div>
          );
        })}
      </div>
    </div>
  );
};
